/* DeleteAction.js */

"use strict";

const CATALOG_NAME_MAX_LENGTH = 60;
const CATALOG_NAME_LIST_LENGTH = 10;

class DeleteAction {
    constructor(logger, gameEditor, modalUserFeedback, activeView, userSession, OsImageCatalogEntity) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._catalogEntity = OsImageCatalogEntity;
        this._selectedCatalogIds = [];
        this._selectedCatalogNames = [];

        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedCatalogIds = this._activeView.getSelectedCatalogIds().selectedRows || [];
        }

        this.run = this.run.bind(this);
    }

    run() {
        if (this._selectedCatalogIds.length) {
            this._activeView.pagingFeed
                .waitForRangeIdsUpdated()
                .then(() => {
                    if (this._selectedCatalogIds.length <= CATALOG_NAME_LIST_LENGTH) {
                        return this._activeView.pagingFeed.getCatalogEntitiesNameById(this._selectedCatalogIds);
                    }
                    return Promise.resolve();
                })
                .then((selectedCatalogNames) => {
                    this._selectedCatalogNames = selectedCatalogNames || [];
                    if (this._selectedCatalogIds.length <= CATALOG_NAME_LIST_LENGTH) {
                        if (Array.isArray(this._selectedCatalogNames) && this._selectedCatalogNames.length > 0) {
                            let s = this._selectedCatalogNames.length > 1 ? "ies" : "y";
                            this._message = "Are you sure you want to permanently delete the selected entr" + s + "?\n";
                            Object.keys(this._selectedCatalogNames).forEach((id) => {
                                let catalogName = this._selectedCatalogNames[id];
                                let shortCatalogName =
                                    catalogName.length > CATALOG_NAME_MAX_LENGTH ? catalogName.substr(0, CATALOG_NAME_MAX_LENGTH) + "…" : catalogName;
                                this._message += "\n" + shortCatalogName;
                            });
                            return Promise.resolve();
                        } else {
                            return Promise.reject(new Error("Cannot retrieve the selected catalogs"));
                        }
                    } else {
                        this._message = `Are you sure you want to permanently delete the selected ${this._selectedCatalogIds.length} entries?\n`;
                        return Promise.resolve();
                    }
                })
                .then(() => {
                    return this._gameEditor.runQuickConfirmationActionWorkflow(
                        {
                            message: this._message,
                            title: "Delete",
                            confirmDetails: {
                                text: "Confirm",
                                type: "destructive"
                            },
                            rejectDetails: {
                                text: "Cancel",
                                type: "text"
                            }
                        },
                        () => {
                            let itemsToDelete = this._selectedCatalogIds.map((entityId) =>
                                this._catalogEntity.delete(this._activeOrgId, "OsImageCatalog", entityId)
                            );
                            return Promise.all(itemsToDelete).then(() => {
                                this._activeView.resetSelection();
                                if (this._activeView && this._activeView.pagingFeed && this._activeView.pagingFeed.feedUpdate) {
                                    this._activeView.pagingFeed.feedUpdate();
                                }
                                return Promise.resolve();
                            });
                        }
                    );
                })
                .catch((err) => {
                    this._logger.warn({ error: err }, "DeleteAction.run() - Error");
                    return this._modalUserFeedback.displayError({ error: { errorMsg: err } });
                });
        } else {
            return Promise.resolve();
        }
    }
}

module.exports = DeleteAction;

DeleteAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.OsImageCatalog"
];

DeleteAction.$displayDetails = {
    type: "Action",
    name: "DeleteAction",
    icon: "common.trash_bin",
    shown: true,
    title: "Delete Entries",
    order: 5
};
